<template>
  <div>
    <table class="dd-stats mt-2">
      <thead>
        <tr>
          <th class="dd-stats-label">group</th>
          <th>n</th>
          <th v-for="level in table.outcomeLevels" :key="'ct-h-' + level">
            <span class="dd-wrap">{{ level }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in table.rows" :key="'ct-r-' + row.level">
          <td class="dd-stats-label">{{ row.level }}</td>
          <td>{{ row.n }}</td>
          <td v-for="(count, i) in row.counts" :key="'ct-c-' + i">
            {{ count }}
            <span class="dd-share">{{ share(row.percents[i]) }}</span>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-if="table.hiddenOutcomeLevels > 0" class="dd-note mt-1">
      {{ table.hiddenOutcomeLevels }} rarer level{{
        table.hiddenOutcomeLevels === 1 ? '' : 's'
      }}
      not shown, so rows total less than 100%.
    </div>
  </div>
</template>

<script>
import { formatPercent } from '@/utils/dashboard';

export default {
  name: 'ContingencyTable',
  props: {
    // a contingencyTable() result
    table: {
      type: Object,
      required: true,
    },
  },
  methods: {
    share(p) {
      return p == null ? '' : `(${formatPercent(p)})`;
    },
  },
};
</script>

<style scoped>
.dd-stats {
  width: 100%;
  border-collapse: collapse;
  font-family: monospace;
  font-size: 11px;
  color: #333;
}
.dd-stats th {
  text-align: right;
  vertical-align: bottom;
  font-weight: 400;
  color: #777;
  padding: 2px 6px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.dd-stats td {
  text-align: right;
  padding: 2px 6px;
  white-space: nowrap;
}
/* both axes of this table are level names, and either can run long */
.dd-wrap {
  display: inline-block;
  max-width: 10em;
  white-space: normal;
  overflow-wrap: break-word;
}
.dd-stats-label {
  text-align: left !important;
  max-width: 12em;
  white-space: normal;
  overflow-wrap: break-word;
}
.dd-share {
  color: #777;
}
.dd-note {
  font-size: 11px;
  color: #777;
}
</style>
